<template>
  <div
    v-if="personsList.length"
    :class="{'content-block': !previewModeOnly}"
  >
    <h2
      v-if="!previewModeOnly"
      class="mb-6"
    >
      Friends and People
    </h2>
    <p v-if="!previewModeOnly">
      {{ description }}
    </p>

    <RcSwiper
      :items="personsList"
      :class="{'friends-carousel': !previewModeOnly}"
    >
      <template #slide="{ item }">
        <div class="carousel-card">
          <div class="carousel-card__image">
            <img
              :src="item.image"
              alt=""
            >
          </div>
          <div class="carousel-card__content">
            <div class="carousel-card__content-title">
              {{ item.name }}
            </div>
            <div class="carousel-card__content-text">
              <strong>{{ item.match }}%</strong> Match
            </div>
          </div>
        </div>
      </template>
    </RcSwiper>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
import RcSwiper from '../common/RcSwiper.vue'
import { useDisplay, DisplayInstance } from 'vuetify'

@Component({
  components: {
    RcSwiper,
  },
})
export default class PropertyFriends extends Vue {
  @Prop({ type: Boolean }) previewModeOnly!: boolean
  @Prop({ type: String }) propertyId!: string
  @Prop({ type: String }) description!: string

  breakpoint: DisplayInstance
  mounted () {
    this.breakpoint = useDisplay()
    if (this.propertyId) {
      this.loadPropertyFriends()
    }
  }

  @Watch('propertyId')
  onPropertyIdLoaded () {
    this.loadPropertyFriends()
  }

  async loadPropertyFriends () {
    const data = await this.$api.propertyFriend.get(this.propertyId)
    this.personsList = data.map(({ user, match_percentage }) => ({
      name: user ? `${user.first_name} ${user.last_name[0]}.` : '',
      match: match_percentage,
      image: user ? user.image : null,
    }))
  }

  personsList = []

  get itemsPerPage () {
    return this.breakpoint.smAndDown.value ? 2 : 4
  }
}
</script>

<style lang="scss">
.friends-carousel {
  .carousel-card {
    height: 21.25rem;
  }
}
</style>
